import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { userVipTime } from "@/api/index.js"; 
export default new Vuex.Store({
    state: {
        // header部分
        nowDate:'',//当前日期
        // 首页免费部分的品种列表
        selectedBreed: 0,  // 初始选中的 breed 的索引
        breedList:[
            {   
                id: 0, 
                name: '小麦',
            },
            {
                id: 1, 
                name: '玉米',
            },
            {
                id: 2, 
                name: '稻谷',
            },
            {
                id: 3, 
                name: '油脂油料',
            },
             {
                id: 4, 
                name: '牧原定制数据',
            },
        ],
        breed:'小麦',//初始品种
        kindbreedList:[
            [
                {
                    label: '小麦',
                    value: '混麦',
                }, 
                {
                    label: '春小麦',
                    value: '春小麦',
                }, 
                {
                    label: '白小麦',
                    value: '白小麦',
                }, 
                {
                    label: '红小麦',
                    value: '红小麦',
                }, 
                {
                    label: '精制粉',
                    value: '小麦粉',
                }, 
                {
                    label: '麸皮',
                    value: '麸皮',
                }, 
                {
                    label: '次粉',
                    value: '次粉',
                },
                {
                    label: '标粉',
                    value: '标粉',
                },
                // {
                //     label: '藁优2018',
                //     value: '藁优2018',
                // },
                // {
                //     label: '济南17',
                //     value: '济南17',
                // },
                // {
                //     label: '师栾02-1',
                //     value: '师栾02-1',
                // },
                // {
                //     label: '西农979',
                //     value: '西农979',
                // },
                // {
                //     label: '新麦26',
                //     value: '新麦26',
                // },
                // {
                //     label: '郑麦366',
                //     value: '郑麦366',
                // },
                // {
                //     label: '郑麦9023',
                //     value: '郑麦9023',
                // },
            ],
            [
                {
                    label: '玉米',
                    value: '玉米',
                }, 
                {
                    label: '玉米淀粉',
                    value: '玉米淀粉',
                }, 
                {
                    label: 'DDGS',
                    value: 'DDGS',
                }, 
                {
                    label: '酒精',
                    value: '工业酒精',
                },
                {
                    label: '蛋白粉',
                    value: '玉米蛋白粉',
                },
                {
                    label: '胚芽粕',
                    value: '玉米胚芽粕',
                },
                {
                    label: '玉米油',
                    value: '玉米油',
                },
                {
                    label: '玉米纤维',
                    value: '玉米纤维',
                },
            ],
            [
                // {
                //     label: '圆粒粳稻',
                //     value: '圆粒粳稻',
                // },
                // {
                //     label: '圆粒粳米',
                //     value: '圆粒粳米',
                // },
                // {
                //     label: '长粒粳稻',
                //     value: '长粒粳稻',
                // },
                // {
                //     label: '长粒粳米',
                //     value: '长粒粳米',
                // },
                {
                    label: '晚籼稻',
                    value: '普通中晚籼稻',
                },
                {
                    label: '早籼稻',
                    value: '早籼稻',
                },
                {
                    label: '早籼米',
                    value: '早籼米',
                },
                {
                    label: '稻花香米',
                    value: '稻花香米',
                },
                {
                    label: '稻花香',
                    value: '稻花香',
                },
                {
                    label: '丰两优米',
                    value: '丰两优米',
                },
                {
                    label: '黄华占米',
                    value: '黄华占米',
                },
                {
                    label: '粳糯米',
                    value: '粳糯米',
                },
                {
                    label: '超级稻',
                    value: '超级稻',
                },
                {
                    label: '长粒香米',
                    value: '长粒香米',
                },
                {
                    label: '米糠',
                    value: '米糠',
                },
                {
                    label: '米糠粕',
                    value: '米糠粕',
                },
                {
                    label: '米糠油',
                    value: '米糠油',
                },
                {
                    label: '稻壳',
                    value: '稻壳',
                },
            ],
            [
                {label:"大豆",value:'国产大豆(食品)'},
                {label:"豆油",value:'豆油'},
                {label:'豆粕',value:'豆粕'},
                {label:'油菜籽',value:'油菜籽'},
                {label:'菜籽油',value:'菜籽油'},
                {label:'菜籽油（进口）',value:'菜籽油（进口）'},
                {label:'菜粕',value:'菜粕'},
                {label:'花生仁',value:'花生仁'},
                {label:'花生油',value:'花生油'},
                {label:'花生粕',value:'花生粕'},
                {label:'棕榈油',value:'棕榈油'},
                {
                    label: '玉米油',
                    value: '玉米油',
                },
                {
                    label: '米糠油',
                    value: '米糠油',
                },
            ], 
            [
                {
                    label: '玉米',
                    value: '牧原定制数据',
                }, 
            ]
        ],
        // 详情页付费部分的品种列表
        // vipSelectedBreed: 0,
        // vip数据
        vipbreedList:[],
        vipText:null,
        // vipbreed:'',
        // kindList:[],
        // 市场价格走势 —— 子品种
        childKindStatus:0,//默认第一个值
        childKindName:'混麦',
        // 侧边栏状态
        sidebarStatus:0,
        // 用户的vip状态
        isVip:false,
        // 用户vip剩余天数
        vipTimeValue:0,
        // 主页弹窗状态
        dialogTableVisible:false,
        // 支付窗口状态
        payFlag:false,
        // 调用状态
        breedFlag:true,
    },
    getters: {
        dialogTableVisible: state => state.dialogTableVisible,
        kindList: (state) => {  
            return state.kindbreedList[state.selectedBreed] || [];  
        },
    },
    
    mutations: {
        UPDATE_NOW_DATE(state, newDate) {  
            state.nowDate = newDate;  
        },
        // 头部导航栏 —— 切换品种
        clickTab(state, index) {  
            // console.log(index);  
            let breed = state.breedList[index];  
            state.selectedBreed = index;  
            state.breed = breed.name;  
            // state.kindList = state.kindbreedList[state.selectedBreed];
            console.log(state.breed,state.selectedBreed);
            // 切换主品种时重置子品种选项  
            state.childKindStatus = 0;   
            if (breed.childkind) {  
                state.childKindName = breed.childkind[0].childname;  
            } else {  
                // console.log('没有子品种');
            }  
            // console.log(state.childKindName);  
        },
        // 主页非vip弹窗关闭
        setDialogTableVisible(state, value) {  
            state.dialogTableVisible = value;  
        },
        // 获取vip品种列表
        getVipbreedList(state, value) {
            // const vipPrefix = '高级'; 
            // const vipPrefixB = '普通'; 
            state.vipbreedList = state.breedList.map(variety => {
                // const vipKeyName = `${vipPrefix}${variety.name}`;
                // let vipInfo;
                // if(value[vipKeyName]){
                //     vipInfo = value[vipKeyName];
                // }else{
                //     const vipKeyNameB = `${vipPrefixB}${variety.name}`;
                //     vipInfo = value[vipKeyNameB] || null;
                // }  
                const vipInfo = value[variety.name] || null; // 尝试从VIP状态中获取数据  
                return { ...variety, vipInfo }; // 返回扩展了vipInfo属性的品种对象  
            });
            // console.log('vip品种列表',value);
            // 将vip数据转为文本
            state.vipText = [];
            let downLoadsum = '';
            // value.forEach(item => { 
            //     // console.log('vip数据',item); 
            //     // const day = parseInt(item.day, 10); // 转换day为数字  
            //     if (day > 0) {  
            //         if(item.type){
            //             state.vipText.push(item.type + '(' + day + '天)'); // 拼接文本   
            //         }else {
                        
            //             downLoadsum = '数据下载剩余条数：' +  day + '条'; // 拼接文本  
            //         }  
            //     }
            // });
            for (let key in value) {
                const day = parseInt(value[key].day, 10);
                if (day > 0) {
                    if(value[key].type){
                        state.vipText.push(value[key].type + '(' + day + '天)'); // 拼接文本   
                    }else {
                        downLoadsum = '数据下载剩余条数：' +  day + '条'; // 拼接文本  
                    }
                }
            }
            state.vipText.push(downLoadsum)
            // console.log('vip文本',state.vipText);
            // state.breed = Object.keys(value)[0];
            if(state.breedFlag){
                console.log(state.vipbreedList);
                
                state.selectedBreed = state.vipbreedList.find(obj => obj.vipInfo !== null && obj.vipInfo !== undefined).id;
                console.log('vip品种列表详细',state.selectedBreed);
                state.breed = state.breedList[state.selectedBreed].name
                state.breedFlag = false;
            }
            // state.breed = state.breedList[state.selectedBreed].name;
        }
    },
    
    actions: {
        // 获取当前日期
        RefreshDate(state){
            // let year = new Date().getFullYear();
            // let month =new Date().getMonth() + 1 < 10? "0" + (new Date().getMonth() + 1): new Date().getMonth() + 1;
            // let date =new Date().getDate() < 10? "0" + new Date().getDate(): new Date().getDate();
            // state.nowDate = year + "-" + month + "-" + date;
            state.nowDate = new Date().format("yyyy-mm-dd");
            // console.log('vuex获取的日期',state.nowDate);
        },
        // 获取用户vip信息
    },
    modules: {
    
    },
})
